/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FormeJuridiqueDto } from '../models/forme-juridique-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des formes juridiques
 */
@Injectable({
  providedIn: 'root',
})
export class FormesJuridiquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation formeJuridiqueGetList
   */
  static readonly FormeJuridiqueGetListPath = '/api/formes-juridiques/list';

  /**
   * Renvoie la liste des formes juridiques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<FormeJuridiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FormeJuridiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des formes juridiques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGetList(params?: {
  }): Observable<Array<FormeJuridiqueDto>> {

    return this.formeJuridiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FormeJuridiqueDto>>) => r.body as Array<FormeJuridiqueDto>)
    );
  }

  /**
   * Path part for operation formeJuridiqueLoadList
   */
  static readonly FormeJuridiqueLoadListPath = '/api/formes-juridiques/load-list';

  /**
   * Renvoie la liste des formes juridiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des formes juridiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.formeJuridiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation formeJuridiqueGet
   */
  static readonly FormeJuridiqueGetPath = '/api/formes-juridiques/{id}';

  /**
   * Renvoie la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGet$Response(params: {

    /**
     * Identifiant de la forme juridique
     */
    id: number;
  }): Observable<StrictHttpResponse<FormeJuridiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormeJuridiqueDto>;
      })
    );
  }

  /**
   * Renvoie la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGet(params: {

    /**
     * Identifiant de la forme juridique
     */
    id: number;
  }): Observable<FormeJuridiqueDto> {

    return this.formeJuridiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<FormeJuridiqueDto>) => r.body as FormeJuridiqueDto)
    );
  }

  /**
   * Path part for operation formeJuridiquePut
   */
  static readonly FormeJuridiquePutPath = '/api/formes-juridiques/{id}';

  /**
   * Met à jour la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiquePut$Response(params: {

    /**
     * Identifiant de la forme juridique à mettre à jour
     */
    id: number;

    /**
     * Forme juridique
     */
    body: FormeJuridiqueDto
  }): Observable<StrictHttpResponse<FormeJuridiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormeJuridiqueDto>;
      })
    );
  }

  /**
   * Met à jour la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiquePut(params: {

    /**
     * Identifiant de la forme juridique à mettre à jour
     */
    id: number;

    /**
     * Forme juridique
     */
    body: FormeJuridiqueDto
  }): Observable<FormeJuridiqueDto> {

    return this.formeJuridiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<FormeJuridiqueDto>) => r.body as FormeJuridiqueDto)
    );
  }

  /**
   * Path part for operation formeJuridiqueDelete
   */
  static readonly FormeJuridiqueDeletePath = '/api/formes-juridiques/{id}';

  /**
   * Supprime la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueDelete$Response(params: {

    /**
     * Identifiant de la forme juridique à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueDelete(params: {

    /**
     * Identifiant de la forme juridique à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.formeJuridiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation formeJuridiquePost
   */
  static readonly FormeJuridiquePostPath = '/api/formes-juridiques';

  /**
   * Crée la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiquePost$Response(params: {

    /**
     * Forme juridique
     */
    body: FormeJuridiqueDto
  }): Observable<StrictHttpResponse<FormeJuridiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormeJuridiqueDto>;
      })
    );
  }

  /**
   * Crée la forme juridique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formeJuridiquePost(params: {

    /**
     * Forme juridique
     */
    body: FormeJuridiqueDto
  }): Observable<FormeJuridiqueDto> {

    return this.formeJuridiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<FormeJuridiqueDto>) => r.body as FormeJuridiqueDto)
    );
  }

  /**
   * Path part for operation formeJuridiqueGetByReference
   */
  static readonly FormeJuridiqueGetByReferencePath = '/api/formes-juridiques/reference/{reference}';

  /**
   * Renvoie la forme juridique recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formeJuridiqueGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGetByReference$Response(params: {

    /**
     * La référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<FormeJuridiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormesJuridiquesService.FormeJuridiqueGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormeJuridiqueDto>;
      })
    );
  }

  /**
   * Renvoie la forme juridique recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formeJuridiqueGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formeJuridiqueGetByReference(params: {

    /**
     * La référence
     */
    reference: string;
  }): Observable<FormeJuridiqueDto> {

    return this.formeJuridiqueGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<FormeJuridiqueDto>) => r.body as FormeJuridiqueDto)
    );
  }

}
